var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Checkmark-Circle-2/Line",
    transform: "translate(-2.000000, -2.000000)",
    fill: "#28ABB9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.9999996,2 L12.2799045,2.0038418 C17.6733312,2.15206821 21.9999996,6.57075806 21.9999996,12 L21.9999996,12 L21.9961578,12.279905 C21.8479314,17.6733316 17.4292419,22 11.9999996,22 C6.47714956,22 1.99999956,17.52285 1.99999956,12 C1.99999956,6.47715 6.47714956,2 11.9999996,2 L11.9999996,2 Z M11.9999997,4 C7.58171965,4 3.99999965,7.58172 3.99999965,12 C3.99999965,16.41828 7.58171965,20 11.9999997,20 L11.9999997,20 L12.2491791,19.9961932 C16.5521638,19.8645429 19.9999997,16.3349162 19.9999997,12 L19.9999997,12 L19.9961928,11.7508206 C19.8645426,7.44783584 16.3349159,4 11.9999997,4 Z M12.7071,15.2929 C13.097624,15.683424 13.097624,16.31659 12.7071,16.70711 C12.316576,17.097634 11.68341,17.097634 11.29289,16.70711 C10.902366,16.316586 10.902366,15.68342 11.29289,15.2929 C11.683414,14.902376 12.31658,14.902376 12.7071,15.2929 Z M12,7 L12.1166211,7.00672773 C12.61396,7.06449283 13,7.48716407 13,8 L13,8 L13,13 C13,13.5522852 12.552285,14 12,14 C11.447715,14 11,13.5522852 11,13 L11,13 L11,8 L11,8 L11.0067277,7.88337883 C11.0644928,7.38603997 11.4871639,7 12,7 L12,7 Z",
    id: "Fill"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.f9a57e9c470a34369abd17727b0987cd.svg";
export { ForwardRef as ReactComponent };